import { useLocation, useNavigate } from 'react-router';
import { Meta } from '@/components/common';
import { ResetPasswordForm } from '@/components/features/auth';
import { AuthLayout } from '@/components/layout';
import { CUSTOMER_AUTH_COPY, ROUTES } from '@/constants';

/**
 * Self-service password reset, reached from "Reset password" on the sign-in
 * form. Public, and kept off-limits to a signed-in user by RequireAnonymous
 * like login itself.
 */
export function ResetPasswordPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Whatever was typed on the sign-in form, carried across by its link.
  const state = location.state as { email?: unknown } | null;
  const initialEmail = typeof state?.email === 'string' ? state.email : '';

  return (
    <>
      <Meta title="Reset password" description="Reset your NuDent account password." />

      <AuthLayout {...CUSTOMER_AUTH_COPY}>
        <ResetPasswordForm
          initialEmail={initialEmail}
          onBack={() => void navigate(ROUTES.login)}
          onComplete={(email) =>
            void navigate(ROUTES.login, { replace: true, state: { passwordReset: true, email } })
          }
        />
      </AuthLayout>
    </>
  );
}
